module.exports = __webpack_public_path__ + "img/capitole-2.86bc3368.jpg";